export const STATUSES = {
	PENDING: 0,
	PAID: 1,
};
